import { useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'
import { useAppSelector } from 'state'
import { useDeserializedFarmFromLpSymbol, useDeserializedFarmFromLpPair } from 'state/farms/useDeserializedFarms'
import { getBalanceAmount } from 'utils/formatBalance'
import Tokens from 'config/constants/tokens'

export const useIsAllFarmUserDataLoaded = () => {
  return useAppSelector((state) => state.farms.allUserDataLoaded)
}

export const useLpTokenPrice = (symbol: string, _version: number) => {
  const farm = useDeserializedFarmFromLpSymbol(symbol)
  if (!farm || !(farm.lpTotalSupply.gt(0) && farm.lpTotalInQuoteToken.gt(0))) return BIG_ZERO

  // Total value of base token in LP
  const valueOfBaseTokenInFarm = new BigNumber(farm.tokenPriceUsdc).times(farm.tokenAmountTotal)
  // Double it to get overall value in LP
  const overallValueOfAllTokensInFarm = valueOfBaseTokenInFarm.times(2)
  // Divide total value of all tokens, by the number of LP tokens
  const totalLpTokens = getBalanceAmount(farm.lpTotalSupply)
  return overallValueOfAllTokensInFarm.div(totalLpTokens)
}

export const usePriceVvsUsdc = (): BigNumber => {
  const vvsCroFarm = useDeserializedFarmFromLpPair(Tokens.vvs, Tokens.wcro)
  const vvsPriceUsdcAsString = vvsCroFarm?.tokenPriceUsdc ?? '0'

  const vvsPriceUsdc = useMemo(() => {
    return new BigNumber(vvsPriceUsdcAsString)
  }, [vvsPriceUsdcAsString])

  return vvsPriceUsdc
}
